import React from 'react'
import Slider from "react-slick";
import DefaultButton from '../../components/DefaultButton';
import { useModal } from '../../contexts/ModalContext';

const sliderData = [
  {
    image: "/assets/images/home-banner-3.webp",
    title: "Enterprise-Grade Document Storage Built for Scale.",
  },
  {
    image: "/assets/images/home-banner-2.webp",
    title: "secure. structure. searchable.",
  },
  {
    image: "/assets/images/home-banner-4.webp",
    title: "Unlock the Power of Intelligent Document Management.",
  },
]

export default function HomeBanner() {

  const { openQueryModal } = useModal();

  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 2500,
    autoplaySpeed: 5000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    pauseOnHover: false,
    cssEase: "ease",
    draggable: true,
  };

  return (
    <>
      <section className="banner-section header-gap">
        <Slider {...settings}>
          {sliderData.map((item, index) => (
            <div className='banner-slidebox' key={index}>
              <img src={item?.image} className="img-responsive banner-thumb" alt="Banner"  />
              <div className="container">
                <div className="row">
                  <div className="col-lg-6 col-md-8">
                    <div className="banner-head">
                      <span className="heading">{item?.title}</span>
                      <DefaultButton text={"know more"} onClick={openQueryModal}/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </section>
    </>
  )
}
